var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 7.875C4.57417 7.875 4.64667 7.89699 4.70834 7.9382C4.77001 7.9794 4.81807 8.03797 4.84645 8.10649C4.87484 8.17502 4.88226 8.25042 4.86779 8.32316C4.85333 8.3959 4.81761 8.46272 4.76516 8.51517C4.71272 8.56761 4.6459 8.60332 4.57316 8.61779C4.50042 8.63226 4.42502 8.62484 4.35649 8.59645C4.28797 8.56807 4.2294 8.52001 4.1882 8.45834C4.14699 8.39667 4.125 8.32417 4.125 8.25C4.125 8.15054 4.16451 8.05516 4.23484 7.98484C4.30516 7.91451 4.40054 7.875 4.5 7.875Z",
    stroke: "#5F5457",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 15.375C19.5742 15.375 19.6467 15.397 19.7083 15.4382C19.77 15.4794 19.8181 15.538 19.8465 15.6065C19.8748 15.675 19.8823 15.7504 19.8678 15.8232C19.8533 15.8959 19.8176 15.9627 19.7652 16.0152C19.7127 16.0676 19.6459 16.1033 19.5732 16.1178C19.5004 16.1323 19.425 16.1248 19.3565 16.0965C19.288 16.0681 19.2294 16.02 19.1882 15.9583C19.147 15.8967 19.125 15.8242 19.125 15.75C19.125 15.6505 19.1645 15.5552 19.2348 15.4848C19.3052 15.4145 19.4005 15.375 19.5 15.375Z",
    stroke: "#5F5457",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 4.5H2.25C1.42157 4.5 0.75 5.17157 0.75 6V18C0.75 18.8284 1.42157 19.5 2.25 19.5H21.75C22.5784 19.5 23.25 18.8284 23.25 18V6C23.25 5.17157 22.5784 4.5 21.75 4.5Z",
    stroke: "#5F5457",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
    stroke: "#5F5457",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.ff8407cd1a40fa9a1ac7e4534c9921fc.svg";
export { ForwardRef as ReactComponent };